module.exports = __webpack_public_path__ + "img/aupply_02.dbea94bd.jpg";